import { Divider, Grid, Typography } from '@mui/material';
import LongTextWithTooltip from 'lib/designSystem/LongTextWithTooltip';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import { formatDate, formatMoney } from 'lib/functions/utils';
import React from 'react';

interface Request {
  source: string;
  pendingAccounts: any[];
  documentsApplied: any[];
  businessName: string;
  businessIdentifier: string;
  amountToDepositTotal: number;
  guaranteeAmount: number;
  documents: any[];
  payments: any[];
  amountToApply: number;
  amount: number;
  status: string;
  createdAt: Date;
  executedAt: Date;
}

interface Props {
  request: Request;
}

const PayOutSummary = (props: Props) => {
  const { request } = props;

  let businesName = '';
  let businessIdentifier = '';

  const divStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '12px 0px',
  };

  const DetailsSummary = () => (
    <div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Estado
        </Typography>
        <Typography variant="body1">
          {cellFormat(request.status, 'status')}
        </Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Destinatario
        </Typography>
        <Typography variant="body1">
          <LongTextWithTooltip text={businesName} />
        </Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Rut cliente
        </Typography>
        <Typography variant="body1">{businessIdentifier}</Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Fecha de creación
        </Typography>
        <Typography variant="body1">{formatDate(request.createdAt)}</Typography>
      </div>
      <div style={divStyle}>
        <Typography fontWeight={600} variant="body1">
          Fecha de operación
        </Typography>
        <Typography variant="body1">
          {request.executedAt ? formatDate(request.executedAt) : '-'}
        </Typography>
      </div>
    </div>
  );

  const AmountSummary = () => {
    businesName = request.pendingAccounts?.[0].businessName;
    businessIdentifier = request.pendingAccounts?.[0].businessIdentifier;
    const amountPendingAccounts = request.pendingAccounts.reduce(
      (acc: any, payment: any) => {
        return acc + payment.amount;
      },
      0,
    );
    const amountAppliedDocuments = request.documentsApplied.reduce(
      (acc: any, payment: any) => {
        return acc + payment.amount;
      },
      0,
    );
    return (
      <div>
        <Typography fontWeight={600} variant="h6">
          Resumen Montos
        </Typography>
        <div style={divStyle}>
          <Typography fontWeight={600} variant="body1">
            Cuentas pendientes
          </Typography>
          <Typography variant="body1">
            {formatMoney(amountPendingAccounts)}
          </Typography>
        </div>
        <div style={divStyle}>
          <Typography fontWeight={600} variant="body1">
            Documentos aplicados
          </Typography>
          <Typography variant="body1">
            {formatMoney(-amountAppliedDocuments)}
          </Typography>
        </div>
        <Divider />
        <div style={divStyle}>
          <Typography fontWeight={600} variant="body1">
            Total a pagar
          </Typography>
          <Typography variant="body1">
            {formatMoney(amountPendingAccounts - amountAppliedDocuments)}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <DetailsSummary />
        </Grid>
        <Grid item xs={6}>
          {AmountSummary()}
        </Grid>
      </Grid>
    </div>
  );
};

export default PayOutSummary;
